/* eslint-disable no-param-reassign */
import React, { memo } from 'react';
import { message } from 'antd';
import PropTypes from 'prop-types';
import { CopyOutlined } from '@ant-design/icons';

const Clipboard = ({ item, className }) => {
  if (!(typeof item === 'object')) {
    item = { label: item, value: item };
  }
  const copyToClipboard = () => {
    const textField = document.createElement('textarea');
    textField.innerText =
      typeof item.value === 'object' ? JSON.stringify(item.value) : item.value;
    document.body.appendChild(textField);
    textField.select();
    document.execCommand('copy');
    textField.remove();
    message.success(
      <span className="mr-1">
        <span className="fs-primary fw-600">{item.label}</span> copied to
        clipboard
      </span>
    );
  };
  return (
    <>
      <CopyOutlined
        onClick={copyToClipboard}
        onKeyPress={copyToClipboard}
        className={`${className} json-clip icon-copy-clipboard`}
      />
      {/* <span
      className={`${className} material-icons icon-copy-clipboard`}
      role="button"
      tabIndex={0}
      onClick={copyToClipboard}
      onKeyPress={copyToClipboard}
    >
      content_copy
    </span> */}
    </>
  );
};

Clipboard.propTypes = {
  item: PropTypes.object,
  className: PropTypes.object
};

export default memo(Clipboard);
